<template>
  <div>
    <div style="display: flex; justify-content: space-between; gap: 20px; margin-bottom: 20px">
      <div style="width: 30%;">
        <p>Выберите дату и время</p>

        <v-datetime-picker
          v-model="dateFrom"
          color="accent"
          label="Выберите дату от"
        />

        <v-datetime-picker
          v-model="dateTo"
          color="accent"
          label="Выберите дату до"
        />

        <v-text-field
          v-model="searchBill"
          append-icon="search"
          color="accent"
          label="Номер кошелька"
          single-line
          hide-details
          @keypress="filterInput"
        />
        <br>

        <v-text-field
          v-model="searchId"
          color="accent"
          append-icon="search"
          label="Id пользователя"
          single-line
          hide-details
          type="number"
        />
        <br>

        <v-text-field
          v-model="outerTransactionId"
          append-icon="search"
          color="accent"
          label="Внешний id операции"
          single-line
          hide-details
        />
      </div>

      <div style="width: 30%;">
        <v-text-field
          v-model="transactionId"
          append-icon="search"
          color="accent"
          label="id операции"
          single-line
          hide-details
        />
      </div>

      <div class="filter-wrap">
        <v-select
          v-model="currentOperFilter"
          class="filter"
          :items="dropdownOperItems"
          color="accent"
          label="Тип транзакции"
          item-title="title"
        >
          <template #selection="{ item }">
            {{ item.title }}
          </template>

          <template #item="{ item }">
            {{ item.title }}
          </template>
        </v-select>

        <v-select
          v-model="currentOperStatusFilter"
          class="filter"
          :items="dropdownStatusItems"
          color="accent"
          label="Статус транзакции"
          item-title="title"
        >
          <template #selection="{ item }">
            {{ item.title }}
          </template>

          <template #item="{ item }">
            {{ item.title }}
          </template>
        </v-select>

        <v-select
          v-model="currentComment"
          class="filter"
          :items="dropdownComments"
          color="accent"
          label="Причина отмены"
          item-title="title"
        >
          <template #selection="{ item }">
            {{ item.title }}
          </template>

          <template #item="{ item }">
            {{ item.title }}
          </template>
        </v-select>

        <v-select
          v-model="currentStatusFilter"
          :items="dropdownItems"
          color="accent"
          label="Статус апелляции"
          item-title="title"
        >
          <template #selection="{ item }">
            {{ item.title }}
          </template>
          <template #item="{ item }">
            {{ item.title }}
          </template>
        </v-select>
      </div>
    </div>

    <paginated-table
      ref="paginatedTable"
      :items="transactions"
      :pullFunction="getTransactions"
      :headers="headers"
      :pagination.sync="pagination"
      :loading="loading"
    >
      <template #items="props">
        <td>{{ props.item.created_at }}</td>
        <td>{{ props.item.user.id }}</td>
        <td>
          <v-btn
            text
            small
            flat
            :to="{ name: 'user', params: { user: props.item.user.id } }"
            class="user_link"
          >
            {{ props.item.user.name }}
          </v-btn>
        </td>
        <td>{{ props.item.operation }}</td>
        <td>{{ props.item.method }}</td>
        <td>{{ props.item.payway }}</td>
        <td style="display: flex; align-items: center; gap: 8px">
          {{ shortWord(props.item.payment_transaction_id) }}   <v-icon
            v-if="props.item.payment_transaction_id"
            style="cursor: pointer"
            small
            @click="copyID(props.item.payment_transaction_id)"
          >
            content_copy
          </v-icon>
        </td>
        <td>
          <div style="display: flex; align-items: center; gap: 8px">
            {{ shortWord(props.item.outer_transaction_id) }}
            <v-icon
              v-if="props.item.outer_transaction_id"
              style="cursor: pointer"
              small
              @click="copyID(props.item.outer_transaction_id)"
            >
              content_copy
            </v-icon>
          </div>
        </td>
        <td>{{ getStatus(props.item.status) }}</td>
        <td>{{ props.item.comment }}</td>
        <td>{{ props.item.bill }}</td>
        <td>{{ props.item.bank_name }}</td>
        <td>{{ props.item.amount }}</td>
        <td>
          <div
            v-if="appealCreateCondition(props.item)"
            style="display: flex; align-items: center; gap: 8px"
          >
            {{ getAppealStatus(props.item.appeal_status) }}

            <v-btn
              v-if="props.item.appeal_status === 3 || !props.item.appeal_status"
              fab
              style="width: 32px; height: 32px; margin-left: auto"
              color="secondary"
              @click="$router.push({
                path: `/users/${props.item.id}/appeal`,
                query: { new: true }
              })"
            >
              <v-icon
                small
              >
                add
              </v-icon>
            </v-btn>

            <v-btn
              v-else
              fab
              style="width: 32px; height: 32px; margin-left: auto"
              color="secondary"
              @click="$router.push({ path: `/users/${props.item.id}/appeal` })"
            >
              <v-icon
                small
              >
                edit
              </v-icon>
            </v-btn>
          </div>
        </td>
      </template>
    </paginated-table>

    <v-snackbar
      v-model="wasCopied"
      color="green"
    >
      <p style="margin: 0 auto">Скопировано!</p>
    </v-snackbar>
  </div>
</template>

<script>
import PaginatedTable from '@/components/PaginatedTable.vue'
import { getTransactions } from '../../../../../api/transactions'
import VueMixin from '@/components/VueMixin.vue'

export default {
  name: 'TransactionsTable',
  components: { PaginatedTable },
  mixins: [VueMixin],
  data () {
    return {
      transactions: [],
      loading: true,
      wasCopied: false,
      page: 1,
      pagination: {
        sortBy: 'created_at',
        descending: true
      },
      dateTo: null,
      dateFrom: null,
      headers: [
        { text: 'Дата/время создания', value: 'created_at' },
        { text: 'ID пользователя', value: 'user_id' },
        { text: 'Ник', value: 'user_name' },
        { text: 'Тип операции', value: 'operation' },
        { text: 'Метод', value: 'method' },
        { text: 'Платежная система', value: 'payway' },
        { text: 'ID операции', value: 'payment_transaction_id' },
        { text: 'Внешний ID операции', value: 'outer_transaction_id' },
        { text: 'Статус', value: 'status' },
        { text: 'Причина отмены', value: 'comment' },
        { text: 'Номер карты/кошелька', value: 'bill' },
        { text: 'Банк', value: 'bank_name' },
        { text: 'Сумма', value: 'amount' },
        { text: 'Апелляция', value: 'appeals' }
      ],
      currentStatusFilter: null,
      currentOperFilter: null,
      dropdownOperItems: [
        {
          title: 'Все',
          value: null
        },
        {
          title: 'Вывод',
          value: 'Вывод'
        },
        {
          title: 'Пополнение',
          value: 'Пополнение'
        }
      ],
      currentOperStatusFilter: null,
      dropdownStatusItems: [
        {
          title: 'Все',
          value: null
        },
        {
          title: 'В обработке',
          value: 0
        },
        {
          title: 'Отказано',
          value: 1
        },
        {
          title: 'Принято',
          value: 2
        },
        {
          title: 'Запрос отправлен',
          value: 4
        },
        {
          title: 'На апелляции',
          value: 7
        },
        {
          title: 'На бэке',
          value: 9
        }
      ],
      searchId: '',
      searchBill: '',
      outerTransactionId: '',
      transactionId: '',
      dropdownItems: [
        {
          title: 'Все',
          value: null
        },
        {
          title: 'Отказано',
          value: 1
        },
        {
          title: 'Успешно',
          value: 2
        },
        {
          title: 'Ошибка',
          value: 3
        },
        {
          title: 'Отправлен',
          value: 4
        }
      ],
      currentComment: null,
      dropdownComments: [
        {
          title: 'Все',
          value: null
        },
        {
          title: 'Передумал делать депозит',
          value: 'Передумал делать депозит'
        },
        {
          title: 'Невозможно перевести на эти реквизиты',
          value: 'Невозможно перевести на эти реквизиты'
        },
        {
          title: 'Другое',
          value: 'Другое'
        }
      ]
    }
  },
  watch: {
    currentComment () {
      this.getTransactions(1)
    },
    currentOperStatusFilter () {
      this.getTransactions(1)
    },
    currentOperFilter () {
      this.getTransactions(1)
    },
    dateFrom () {
      this.getTransactions(1)
    },
    dateTo () {
      this.getTransactions(1)
    },
    currentStatusFilter () {
      this.getTransactions(1)
    },
    searchId () {
      this.getTransactions(1)
      this.$refs.paginatedTable?.resetPagination()
    },
    searchBill () {
      this.getTransactions(1)
      this.$refs.paginatedTable?.resetPagination()
    },
    outerTransactionId () {
      this.getTransactions(1)
      this.$refs.paginatedTable?.resetPagination()
    },
    transactionId () {
      this.getTransactions(1)
      this.$refs.paginatedTable?.resetPagination()
    }
  },
  created () {
    this.getTransactions(this.page)
  },
  methods: {
    filterInput (e) {
      if (!/[0-9+\b\t]/.test(e.key))
        e.preventDefault()
    },
    appealCreateCondition (item) {
      return item.operation === 'Пополнение' && item.method !== 'admin_panel'
        && item.type === 'h2h' && item.payway && item.count_appeal_files && item.appeal_types
    },
    getAppealStatus (status) {
      if (status === 1)
        return 'Отклонено'
      if (status === 2)
        return 'Успешно'
      if (status === 3)
        return 'Ошибка'
      if (status === 4)
        return 'Отправлен'
    },
    getStatus (status) {
      if (status === 0 || status === 10)
        return 'В обработке'
      if (status === 1)
        return 'Отказано'
      if (status === 2)
        return 'Принято'
      if (status === 4)
        return 'Запрос отправлен'
      if (status === 7)
        return 'На апелляции'
      if (status === 9)
        return 'На бэке'
    },
    getTransactions (page) {
      this.loading = true
      this.page = page
      getTransactions({
        limit: 26,
        offset: (page - 1) * 25,
        sort: 'created_at:desc',
        user_id: this.searchId,
        outer_transaction_id: this.outerTransactionId,
        payment_transaction_id: this.transactionId,
        appeal_status: this.currentStatusFilter,
        bill: this.searchBill,
        date_from: this.dateFrom ? this.formatDateFilter(this.dateFrom) : undefined,
        date_to: this.dateTo ? this.formatDateFilter(this.dateTo) : undefined,
        status: this.currentOperStatusFilter == 0 ? null : this.currentOperStatusFilter,
        statuses: this.currentOperStatusFilter == 0 ? [0, 10] : null,
        operation: this.currentOperFilter,
        with_appeals: 1,
        only_payment_methods: 1,
        comment: this.currentComment ? this.currentComment : undefined
      }).then(response => {
        this.transactions = response.data
        this.loading = false
      })
    },
    shortWord (item) {
      if (item)
        return item.length > 10 ? `${item.slice(0, 10)}...` : item
    },
    copyID (id) {
      navigator.clipboard.writeText(id)
        .then(() => {
          this.wasCopied = true
        })
    }
  }
}
</script>

<style scoped>
.user_link {
  text-transform: none;
  padding: 0;
  min-width: auto;
  margin: 0;
}

.filter-wrap{
  display:flex;
  width: 30%;
  flex-direction: column;
  gap: 15px;

  p{
    margin: 0;
  }
}
</style>
